import Email from './index'
export default [
  {
    path: '/change/email',
    name: 'safe-change-email',
    component: Email
  },
]
